import { render, staticRenderFns } from "./DispatchDocketsForm.vue?vue&type=template&id=027c00fc&"
import script from "./DispatchDocketsForm.vue?vue&type=script&lang=js&"
export * from "./DispatchDocketsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports